import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Toolbar,
  Typography,
  Modal,
  Slide, useMediaQuery, List, ListItemButton, ListSubheader, useTheme, Tooltip, IconButton, Alert, ButtonGroup,
  TextField,
  Avatar,
  Checkbox,
  Snackbar,
  Dialog,
  DialogContent,
  InputAdornment,
  Skeleton,
  Stack,
} from "@mui/material";
import Nocandidate from "../../images/Nocandidate.png"
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';

import React, { useEffect, useRef, useState } from "react";
import AddCandidate from "./Addcandidate";
import AdminCandidatesList from "./AdminCandidatesList";
import FileUploader from "../../candidatesPage/ResumesUpload";
import {
  candidateSelectedResumeAction,
  getActiveCandidatesAction,
  getCandidateResumeListAction,
  getCandidateResumeListActionTemp,
  resetCandidatesAction,
  getPrimaryResumeDetailsAction,
  updatePrimaryResumeAction,
  getCandidateDetailAction,
  deleteResumeAction,
  updateCandidateStatusAction
} from "../../redux/action";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";


import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../user-redux/selector";
import { appSelector } from "../../redux/selector";
import AdminCandidateProfiles from "./AdminCandidateProfiles";
import axios from "axios";
import ResumePdfViewer from "./ResumePDFViewer";
import AdminCandidateContact from "./Admincandidatecontact";
import { Search, InfoOutlined } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import { Email, Phone, LinkedIn, GitHub, Edit, Verified, CheckBox, VerifiedRounded, DeleteRounded, PersonOffOutlined as PersonOffOutlinedIcon, PersonRemove as PersonRemoveIcon } from "@mui/icons-material";
import introImg from "../../../Components/images/intro.png";
import {
  FaGithub,
  FaLinkedinIn,
  FaSkype,
  FaStackOverflow,
} from "react-icons/fa";
import CandidateDetailsView from "../../candidatesPage/CandidateDetailsView";
import { DialogTitle, DialogActions, CircularProgress } from "@mui/material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import InputMask from "react-input-mask";
import Key from "../../../clientVariables.json";
import PhoneInput, { isPossiblePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { parsePhoneNumber } from 'react-phone-number-input';


const modalParseStyles = {
  position: "absolute",
  top: "20%",
  left: "35%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  // maxHeight: "70vh",
  // overflow: "scroll",
};

const sortResumesPrimaryFirst = (list) => {
  if (!Array.isArray(list)) return [];
  return [...list].sort((a, b) => {
    const aPrimary = Number(a?.isPrimary) === 1 ? 1 : 0;
    const bPrimary = Number(b?.isPrimary) === 1 ? 1 : 0;
    return bPrimary - aPrimary;
  });
};

const RightPanelSkeleton = () => (
  <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0, gap: 1 }}>
    <Paper elevation={2} sx={{ p: 1.5, flexShrink: 0 }}>
      <Skeleton variant="rounded" width={120} height={30} />
    </Paper>
    <Grid container spacing={1} sx={{ flex: 1, minHeight: 0 }}>
      <Grid item xs={3.5} sx={{ height: "100%" }}>
        <Paper elevation={2} sx={{ height: "100%", p: 1.5, overflow: "hidden" }}>
          <Skeleton variant="text" width="50%" height={28} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="40%" height={20} sx={{ mb: 2 }} />
          {Array.from({ length: 6 }).map((_, i) => (
            <Box key={i} sx={{ mb: 1.5 }}>
              <Skeleton variant="text" width="75%" height={18} />
              <Skeleton variant="text" width="55%" height={14} />
              <Skeleton variant="text" width="40%" height={14} />
            </Box>
          ))}
        </Paper>
      </Grid>
      <Grid item xs={8.5} sx={{ height: "100%" }}>
        <Paper elevation={2} sx={{ height: "100%", p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
            <Skeleton variant="rounded" width={90} height={32} />
            <Skeleton variant="rounded" width={90} height={32} />
          </Stack>
          <Skeleton variant="text" width="40%" height={22} />
          <Skeleton variant="rounded" height={28} width={160} />
          <Skeleton variant="rounded" height="70%" sx={{ mt: 1, flex: 1, minHeight: 220 }} />
        </Paper>
      </Grid>
    </Grid>
  </Box>
);

const Admincandidates = () => {
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);
  const {
    activeCandidates,
    candidateDetails,
    candidateresumeList,
    candidateSelectedResume,
    activeCandLoading,
    candidateDetailLoading,
    primaryResumeDetailsLoading,
    candidateresumeListLoading,
  } = useSelector(appSelector);
  const theme = useTheme();
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const openFileUploadRef = useRef(null);
  const [resumesRefresh, setResumesRefresh] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const candidatesAPIRequest = useRef(false);
  const [resumes, setResumes] = useState();
  const [selectedResume, setSelectedResume] = useState();
  const [panelTransitionLoading, setPanelTransitionLoading] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null); // New state for selected candidate
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [paginationResetKey, setPaginationResetKey] = useState(0);
  const [uploadContext, setUploadContext] = useState(""); // New state to manage upload context
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs")); // Very small mobile devices
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "sm")); // Regular mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets
  const isDesktop = useMediaQuery(theme.breakpoints.up("md")); // Desktops and larger
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg")); // Small desktops
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops
  const { primaryResumeDetails } = useSelector(appSelector);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [open, setopen] = useState("resume_view");
  const [loading, setLoading] = useState(false);
  const lastLoadedCandidateIdRef = useRef(null);
  const resumeFetchRequestIdRef = useRef(0);
  const [candidateId, setCandidateId] = useState("");
  const [resumeCheckedLength, setResumeCheckedLength] = useState(0);
  const [resumesChecked, setResumesChecked] = useState([]);
  const [selectedButton, setSelectedButton] = useState('resume_view'); // Default is 'resume'
  const [noCandidateFound, setNoCandidateFound] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState("");
  const [editedPhone, setEditedPhone] = useState("");
  const [editedLinkedIn, setEditedLinkedIn] = useState("");
  const [editedGitHub, setEditedGitHub] = useState("");
  const [editedSkype, setEditedSkype] = useState("");
  const [editedStackOverflow, setEditedStackOverflow] = useState("");
  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const navigate = useNavigate();

  const [selectedItems, setSelectedItems] = useState([]);
  const [openInactiveDialog, setOpenInactiveDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [inactiveReason, setInactiveReason] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const handleToggleSelection = (candidateId) => {
    setSelectedItems((prev) =>
      prev.includes(candidateId)
        ? prev.filter((id) => id !== candidateId)
        : [...prev, candidateId]
    );
  };

  const handleMoveToInactive = async () => {
    if (selectedItems.length === 0) return;
    setIsProcessing(true);
    try {
      const data = selectedItems.map((candidateId) => ({
        candidateid: candidateId,
        candidate_status: 0,
        inactive_reason: inactiveReason,
      }));

      await Promise.all(
        data.map((candidateData) =>
          dispatch(updateCandidateStatusAction(candidateData, user?.id))
        )
      );

      toast.success("Candidates moved to inactive successfully");
      setSelectedItems([]);
      setOpenInactiveDialog(false);
      setInactiveReason("");
      const userId = user?.usertype == 13 ? (user?.admin_id != null && user?.admin_id != 0) ? user?.admin_id : user?.id : user?.id;
      await dispatch(resetCandidatesAction());
      dispatch(getActiveCandidatesAction(userId, 1, 500));
    } catch (error) {
      toast.error("Failed to move candidates to inactive");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleDeleteCandidates = async () => {
    if (selectedItems.length === 0) return;
    setIsProcessing(true);
    try {
      const response = await fetch(`${Key.domain}/candidate/delete_candidate`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ candidate_ids: selectedItems }),
      });

      if (response.ok) {
        toast.success("Candidates deleted successfully");
        setSelectedItems([]);
        setOpenDeleteDialog(false);
        setPaginationResetKey((prev) => prev + 1);
        const userId = user?.usertype == 13 ? (user?.admin_id != null && user?.admin_id != 0) ? user?.admin_id : user?.id : user?.id;
        await dispatch(resetCandidatesAction());
        dispatch(getActiveCandidatesAction(userId, 1, 500));
      } else {
        toast.error("Failed to delete candidates");
      }
    } catch (error) {
      toast.error("Error deleting candidates");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCloseDialog = () => {
    setNoCandidateFound(false);
    navigate("/admin-Dashboard");
  };


  const deleteResume = async (resumeId, primary) => {
    const resumeData = {
      resume_id: resumeId,
      user_id: user?.id,
    };
    if (primary === 1) {
      handleOpenSnackbar("Cannot delete primary resume", "error");
    } else {
      const candidateData = {
        candidate_id: user?.candidate_id,
        user_id: user.id,
      };
      await dispatch(deleteResumeAction(resumeData, candidateData));
      await getCandidateResumeList();
    }
  };
  const handleEditClick = () => {
    let resume = selectedResume;
    if ((!resume || !resume.resume_id) && resumes && resumes.length > 0) {
      resume = resumes[0];
      setSelectedResume(resume);
    }
    if (!resume || !resume.resume_id) {
      handleOpenSnackbar("No resume available to edit.", "error");
      return;
    }
    setIsEditing(true);
    setEditPopupOpen(true);
    setEditedTitle(resume?.application_title || "");
    setEditedPhone(resume?.home_phone || "");
    setEditedLinkedIn(resume?.linkedin_url || candidateDetails?.linkedin_url || "");
    setEditedGitHub(resume?.github || candidateDetails?.github || "");
    setEditedSkype(resume?.skype_id || candidateDetails?.skype_id || "");
    setEditedStackOverflow(resume?.stack_overflow || candidateDetails?.stack_overflow || "");
  };
  const handleSave = async () => {
    const candidateId = candidateDetails?.candidate_id || selectedResume?.candidate_id;

    if (!selectedResume?.resume_id) {
      handleOpenSnackbar("No resume selected to update.", "error");
      return;
    }
    if (!candidateId) {
      handleOpenSnackbar("No candidate found for update.", "error");
      return;
    }
    if (!editedTitle) {
      handleOpenSnackbar("Job Title is required.", "error");
      return;
    }
    // Only validate phone if not empty
    if (editedPhone && phoneError) {
      handleOpenSnackbar(phoneError, "error");
      return;
    }
    // Optionally, you can also check here if phone is filled but not valid
    if (editedPhone && !isValidPhoneNumber(editedPhone)) {
      handleOpenSnackbar("Please enter a valid phone number", "error");
      return;
    }

    try {
      setLoading(true);

      const updateData = {
        application_title: editedTitle,
        home_phone: editedPhone, // can be blank
        linkedin_url: editedLinkedIn,
        github_url: editedGitHub,
        skype_id: editedSkype,
        stackoverflow_url: editedStackOverflow
      };

      const response = await axios.put(
        `${Key.domain}/candidate/update-resume-details/${candidateId}/${selectedResume.resume_id}`,
        updateData,
      );

      if (response.data?.success) {
        setSelectedResume(prev => ({
          ...prev,
          application_title: editedTitle,
          home_phone: editedPhone,
          linkedin_url: editedLinkedIn,
          github_url: editedGitHub,
          skype_id: editedSkype,
          stackoverflow_url: editedStackOverflow
        }));
        setIsEditing(false);
        setEditPopupOpen(false);
        handleOpenSnackbar(response.data?.message || "Profile updated successfully", "success");
        await dispatch(getCandidateDetailAction(user?.candidate_id));
        await getCandidateResumeList();
      } else {
        const errorMessage = response.data?.message || "Failed to update profile";
        handleOpenSnackbar(errorMessage, "error");
        console.error('Backend error updating profile:', response.data);
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      handleOpenSnackbar(
        error.message || "Failed to update profile due to network or unexpected error",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    setIsEditing(false);
    setEditPopupOpen(false);
    setEditedTitle(selectedResume?.application_title || "");
    setEditedPhone(selectedResume?.home_phone || "");
  };
  const handleIconClick = () => {
    setIsSearchActive(!isSearchActive);
    setSearchTerm("");
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const closeResumeParserModal = (isClose) => {
    setOpenFileUpload(!isClose);
    if (isClose) {
      setResumesRefresh((prev) => !prev); // Trigger refresh
    }
  };

  const popupsHandler = (msg, severity) => {
    if (msg) {
      handleOpenSnackbar(msg, severity);
      if (msg === "Resume added successfully") {
        setResumesRefresh(true);
      }
    }
  };

  const handleOpenSnackbar = async (message, severity) => {
    await setSnackbarMessage(message);
    await setSnackbarSeverity(severity);
    await setSnackbarOpen(true);
  };

  // Fetch the candidates when component loads
  useEffect(() => {
    const fetch = async () => {
      if (activeCandidates?.length === 0 && !candidatesAPIRequest?.current) {
        candidatesAPIRequest.current = true;
        const userId = user?.usertype == 13 ? user?.admin_id != null ? user?.admin_id : user?.id : user?.id;
        // const response = await dispatch(
        //   getActiveCandidatesAction(userId, 1, 20)
        // );
      }
    };
    fetch();
  }, [activeCandidates, dispatch, user?.id, resumesRefresh]);

  useEffect(() => {
    if (!candidatesAPIRequest.current) {
      if (activeCandidates?.length > 0) {
        dispatch(resetCandidatesAction());
        setNoCandidateFound(false); // Ensure the dialog does not appear
      } else {
        setNoCandidateFound(true); // Show the dialog only after fetching
      }
    }
  }, []); // Depend on activeCandidates to trigger effect after API fetch

  const fetchDataRef = useRef(false);
  const skipInitialResumesRefreshRef = useRef(true);
  const isManuallyUpdatingRef = useRef(false);
  const skipResumeFetchRef = useRef(false);

  // Add this useEffect to update the selectedResume when candidateSelectedResume changes
  useEffect(() => {
    if (candidateSelectedResume) {
      setSelectedResume(candidateSelectedResume);
    }
  }, [candidateSelectedResume]);

  // Also update your resumes state when candidateresumeList changes
  useEffect(() => {
    // Skip if we just manually updated resumes to prevent overwriting with stale data
    if (isManuallyUpdatingRef.current) {
      return;
    }

    if (candidateresumeList && Array.isArray(candidateresumeList)) {
      // Remove duplicates based on resume_id to prevent appending
      const uniqueResumes = candidateresumeList.filter((resume, index, self) =>
        index === self.findIndex((r) => r.resume_id === resume.resume_id)
      );
      const sortedResumes = sortResumesPrimaryFirst(uniqueResumes);

      // Create a fresh array copy to ensure React detects the change
      setResumes(sortedResumes);

      // If no resume is selected yet, select primary (or first) automatically
      if (!selectedResume && sortedResumes.length > 0 && sortedResumes[0]) {
        setSelectedResume(sortedResumes[0]);
      }
    } else if (candidateresumeList === null || candidateresumeList === undefined) {
      setResumes([]);
    }
  }, [candidateresumeList]);

  // Fetch resume data for selected candidate
  useEffect(() => {
    const nextId = candidateDetails?.candidate_id;
    if (!nextId || skipResumeFetchRef.current) return;

    if (String(lastLoadedCandidateIdRef.current) !== String(nextId)) {
      setResumes([]);
      setSelectedResume(null);
      lastLoadedCandidateIdRef.current = nextId;
    }
    //console.log("candidateDetails", candidateDetails)
    fetchDataRef.current = true;
    getCandidateResumeList(nextId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateDetails?.candidate_id, candidateDetails?.user_id]);

  useEffect(() => {
    // Skip mount — initial load already fetches via candidateDetails effect above.
    // After add-modal close, refetch resumes (needed when same candidate stays
    // selected on "already exists", so candidateDetails effect does not re-run).
    if (skipInitialResumesRefreshRef.current) {
      skipInitialResumesRefreshRef.current = false;
      return;
    }
    if (candidateDetails?.candidate_id) {
      getCandidateResumeList(candidateDetails.candidate_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resumesRefresh]);

  const beginCandidateSwitch = () => {
    setPanelTransitionLoading(true);
    setResumes([]);
    setSelectedResume(null);
  };

  const getCandidateResumeList = async (forcedCandidateId, forcedUserId) => {
    const candidateId = forcedCandidateId || candidateDetails?.candidate_id;
    const userId = forcedUserId || candidateDetails?.user_id;
    if (!candidateId || !userId) {
      return;
    }

    const requestId = ++resumeFetchRequestIdRef.current;
    setResumes([]);
    isManuallyUpdatingRef.current = true;

    try {
      let retryCount = 0;
      let maxRetries = 3;
      let response = null;

      while (retryCount < maxRetries) {
        if (requestId !== resumeFetchRequestIdRef.current) return;

        response = await dispatch(
          getCandidateResumeListActionTemp({
            candidate_id: candidateId,
            user_id: userId,
          })
        );

        if (
          response &&
          response.success == 1 &&
          response.data &&
          response.data.length > 0 &&
          response.data[0].filename
        ) {
          break;
        }
        if (retryCount < maxRetries - 1) {
          //console.log(`Filename not ready, retrying... (${retryCount + 1}/${maxRetries})`);
          await new Promise((resolve) => setTimeout(resolve, 1000));
          retryCount++;
        } else {
          console.log("Max retries reached");
          break;
        }
      }

      if (requestId !== resumeFetchRequestIdRef.current) return;

      if (response && response.success == 1 && response.data && response.data.length > 0) {
        const freshResumes = Array.isArray(response.data) ? [...response.data] : [];
        const uniqueResumes = freshResumes.filter(
          (resume, index, self) =>
            index === self.findIndex((r) => r.resume_id === resume.resume_id)
        );
        const sortedResumes = sortResumesPrimaryFirst(uniqueResumes);
        setResumes(sortedResumes);
        const primaryResume = sortedResumes.find(
          (resume) => resume.isPrimary === 1
        );
        const firstResume = sortedResumes[0];

        dispatch(candidateSelectedResumeAction(primaryResume || firstResume));
        setSelectedResume(primaryResume || firstResume);
      } else {
        setResumes([]);
        dispatch(candidateSelectedResumeAction(null));
        setSelectedResume(null);
      }
    } catch (error) {
      if (requestId !== resumeFetchRequestIdRef.current) return;
      console.error("Error fetching resume list:", error);
      setResumes([]);
      dispatch(candidateSelectedResumeAction(null));
      setSelectedResume(null);
    } finally {
      if (requestId === resumeFetchRequestIdRef.current) {
        isManuallyUpdatingRef.current = false;
        setPanelTransitionLoading(false);
      }
    }
  };

  useEffect(() => {
    // Safety net: if no real fetch starts (e.g. same candidate), don't keep skeleton stuck.
    if (
      panelTransitionLoading &&
      !candidateDetailLoading &&
      !candidateresumeListLoading
    ) {
      setPanelTransitionLoading(false);
    }
  }, [panelTransitionLoading, candidateDetailLoading, candidateresumeListLoading]);

  useEffect(() => {
    if (candidateresumeList?.length > 1) {
      const sorted = sortResumesPrimaryFirst(candidateresumeList);
      const primaryResume = sorted.find((r) => r.isPrimary === 1);
      dispatch(candidateSelectedResumeAction(primaryResume || sorted[0]));
    }
  }, [candidateresumeList]);

  // const paperStyles = {
  //   borderRadius: "8px",
  //   height: "100vh",
  //   overflow: "auto"
  // };


  const paperStyles1 = {
    borderRadius: "8px",
    height: "100vh",
    overflow: "scroll",
    padding: "1px"
  }

  const paperStyles0 = {
    borderRadius: "8px",

    overflow: "scroll",
    padding: "1px"
  }

  const resumeCheckedHandler = (isCheck, resumeId) => {
    const resumeData = resumes.filter((data) => resumeId === data.resume_id);

    let extractedResumeId;
    if (resumeData.length > 0) {
      extractedResumeId = resumeData[0].resume_id;
    }
    if (isCheck) {
      setResumeCheckedLength(resumeCheckedLength + 1);
      setResumesChecked((prevChecked) => [...prevChecked, extractedResumeId]);
    } else {
      if (!isCheck) {
        setResumeCheckedLength(resumeCheckedLength - 1);
        setResumesChecked((prevChecked) =>
          prevChecked.filter((id) => id !== extractedResumeId)
        );
      }
    }
  };

  const handleFileChange = (resume) => {
    setSelectedResume(resume);
    dispatch(candidateSelectedResumeAction(resume));
    setopen("resume_view");
    setSelectedButton("resume_view");

  };


  const handleView = (view) => {
    setopen(view);
    setSelectedButton(view);
    // Perform additional actions based on the view (e.g., fetching data)
    if (view === "profile_view") {
      // dispatch(getCandidateDetailAction(candidateDetails?.candidate_id));
    }
  };

  const handleSnackbarClose = (event, reason) => {
    // if (reason === "clickaway") {
    //   return;
    // }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    if (skipResumeFetchRef.current) return;
    if (candidateDetails?.candidate_id) {
      getPrimaryResumeDetails();
    }
  }, [candidateDetails?.candidate_id]);


  const getPrimaryResumeDetails = async (forcedCandidateId) => {
    const candidateId = forcedCandidateId || candidateDetails?.candidate_id;
    if (!candidateId) return;

    const updateData = {
      candidate_id: candidateId,
    };
    const response = await dispatch(getPrimaryResumeDetailsAction(updateData));

    // Log the response to see the fetched data


    // If needed, update your state or perform other actions here
  };

  const fetchResumesAfterUpload = async (candidateId, userId) => {
    if (!candidateId || !userId) return;
    skipResumeFetchRef.current = false;
    await getCandidateResumeList(candidateId, userId);
    await getPrimaryResumeDetails(candidateId);
  };

  const updateprimaryResume = async (resume_id) => {
    setLoading(true);
    const updatedData = {
      candidate_id: user?.candidate_id,
      resumeid: resume_id,
      primary: 1,
    };
    const response = await dispatch(updatePrimaryResumeAction(updatedData));
    if (response?.success === 1 && response?.data?.affectedRows > 0) {
      getPrimaryResumeDetails();
      handleOpenSnackbar(response?.messege, "success");
      getCandidateResumeList();
      setLoading(false);
    } else {
      handleOpenSnackbar("Failed to update primary resume", "error");
      setLoading(false);
    }
  };
  const handlePhoneChange = (value) => {
    setEditedPhone(value);

    if (!value) {
      setPhoneError(""); // No error if phone is blank (optional)
      return;
    }

    try {
      const phoneNumber = parsePhoneNumber(value);
      if (!phoneNumber) {
        setPhoneError("Invalid phone number");
        return;
      }

      const nationalNumber = phoneNumber.nationalNumber;

      if (nationalNumber.length > 10) {
        setPhoneError("Phone number cannot exceed 10 digits after country code");
        return;
      }

      if (nationalNumber.length < 10) {
        setPhoneError("Please enter exactly 10 digits after country code");
        return;
      }

      if (!isValidPhoneNumber(value)) {
        setPhoneError("Invalid phone number");
        return;
      }

      setPhoneError(""); // Valid number, clear error
    } catch (error) {
      setPhoneError("Invalid phone number format");
    }
  };

  const topBarStyles = {
    padding: "10px",
    borderRadius: "4px",
    margin: "5px 5px 5px 5px",
    border: "none",
  };
  const isValidString = (v) =>
    v !== undefined &&
    v !== null &&
    typeof v === "string" &&
    v.trim().length > 0 &&
    v.trim().toLowerCase() !== "null";
  const showRightPanel =
    activeCandidates?.length > 0 &&
    (!searchTerm.trim() ||
      activeCandidates.some((candidate) => {
        const term = searchTerm.toLowerCase();
        return (
          (candidate.candidate_name?.toLowerCase() || "").includes(term) ||
          (candidate.role?.toLowerCase() || "").includes(term)
        );
      }));

  return (
    <Box sx={{ pt: 1, px: 1, mx: { xs: -1, md: -2 }, height: "calc(100vh - 67px)", display: "flex", flexDirection: "column", bgcolor: "#F8F8F8", position: "relative" }}>
      <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
        <Box sx={{ pb: 1 }}>
          <Paper elevation={2}>
            <Toolbar
              style={{ display: "flex", justifyContent: "space-between", minHeight: "42px" }}
            >
              <Button
                variant="contained"
                size="small"
                onClick={() => {
                  skipResumeFetchRef.current = true;
                  setUploadContext("add_candidates");
                  setOpenFileUpload(true);
                }}
                style={{ backgroundColor: "#406882", textTransform: "none", boxShadow: "none", height: "30px" }}
              >
                Add Candidate
              </Button>
            </Toolbar>
          </Paper>
        </Box>

        <Box sx={{ position: "relative", flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
          <Grid container spacing={1} sx={{ flex: 1, minHeight: 0 }}>
            {/* Candidate List */}
            <Grid item xs={2.4} sx={{ height: "100%" }} >
              <Paper elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: "8px", overflow: "hidden" }}>
                <Toolbar
                  sx={{
                    minHeight: "42px !important",
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {selectedItems.length > 0 ? (
                    <>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                        {selectedItems.length} selected
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Tooltip title="Move to Inactive">
                          <IconButton onClick={() => setOpenInactiveDialog(true)} size="small">
                            <PersonOffOutlinedIcon sx={{ color: "#616161" }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Candidates">
                          <IconButton onClick={() => setOpenDeleteDialog(true)} size="small">
                            <PersonRemoveIcon sx={{ color: "#d32f2f" }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </>
                  ) : (
                    <>
                      {isSearchActive ? (
                        <TextField
                          value={searchTerm}
                          onChange={handleSearchChange}
                          placeholder="Search candidates..."
                          variant="outlined"
                          size="small"
                          style={{ flex: 1 }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip title="Search matches candidate name and role">
                                  <InfoOutlined style={{ fontSize: 18, color: "#666", cursor: "pointer" }} />
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                        />
                      ) : (
                        <Typography variant="body1">Candidates</Typography>
                      )}
                      {isSearchActive ? (
                        <CloseIcon
                          onClick={handleIconClick}
                          style={{
                            cursor: "pointer",
                            marginLeft: "10px",
                            color: "#696969",
                          }}
                        />
                      ) : (
                        <SearchIcon
                          onClick={handleIconClick}
                          style={{
                            cursor: "pointer",
                            marginLeft: "10px",
                            color: "#696969",
                          }}
                        />
                      )}
                    </>
                  )}
                </Toolbar>
                <Divider sx={{ margin: 0 }} />
                <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                  <AdminCandidatesList
                    searchTerm={searchTerm}
                    paginationResetKey={paginationResetKey}
                    onSearchChange={handleSearchChange}
                    setOpenFileUpload={setOpenFileUpload}
                    setUploadContext={setUploadContext}
                    setNoCandidateFound={setNoCandidateFound}
                    selectedItems={selectedItems}
                    handleToggleSelection={handleToggleSelection}
                    onCandidateSwitch={beginCandidateSwitch}
                  />
                </Box>
              </Paper>
            </Grid>
            {(activeCandLoading || panelTransitionLoading || candidateDetailLoading || candidateresumeListLoading) && showRightPanel ? (
              <Grid item xs={9.6} sx={{ height: "100%", minHeight: 0, overflow: "hidden" }}>
                <RightPanelSkeleton />
              </Grid>
            ) : showRightPanel ? (
              <Grid item xs={9.6} sx={{ height: "100%", minHeight: 0, overflow: "hidden" }} >
                <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0, gap: 1 }}>

                  {/* Grid 1 — Add Resume toolbar */}
                  <Grid container sx={{ flexShrink: 0 }}>
                    <Grid item xs={12}>
                      <Paper elevation={2} sx={{ width: "100%" }}>
                        <Toolbar
                          sx={{
                            minHeight: "42px !important",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: { xs: "center", sm: "space-between" },
                          }}
                        >
                          <Button
                            color="primary"
                            variant="contained"
                            size="small"
                            onClick={() => {
                              setUploadContext("add_resumes");
                              setOpenFileUpload(true);
                            }}
                            sx={{ textTransform: "none", backgroundColor: "#1565c0", height: "30px", boxShadow: "none" }}
                          >
                            <AddCircleOutlineRoundedIcon fontSize="small" />&nbsp;Resume
                          </Button>

                          <Box sx={{ flexGrow: 1 }} />

                          <Box sx={{ display: primaryResumeDetails ? "block" : "none" }}>
                            <Typography variant="body1" sx={{ fontWeight: "600", fontSize: '1rem', marginRight: '5px', color: "#666666" }}>
                              #{selectedResume?.resume_id} - {selectedResume?.full_name} - {selectedResume?.application_title}
                            </Typography>
                          </Box>

                          <Box sx={{ flexGrow: 1 }} />
                        </Toolbar>
                      </Paper>
                    </Grid>
                  </Grid>

                  {/* Grid 2 — resume list + resume view */}
                  <Grid container rowSpacing={0} columnSpacing={1} sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
                    <Grid item xs={(isMobile || isTablet || isDesktopSmall) ? 12 : 3} sx={{ height: "100%" }}>
                      <Paper
                        elevation={2}
                        sx={{
                          height: "100%",
                          display: 'flex',
                          flexDirection: 'column',
                          borderRadius: "8px",
                          overflow: 'hidden',
                        }}
                      >
                        {resumes?.length > 0 && (
                          <Toolbar
                            sx={{ pl: { sm: 2 }, pr: { xs: 1, sm: 1 }, minHeight: '48px !important', flexShrink: 0 }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                              <Typography variant="body1">My Resumes</Typography>

                              {resumeCheckedLength > 0 && (
                                <Tooltip title="Delete Resume">
                                  <IconButton onClick={() => deleteResume(selectedResume?.resume_id, selectedResume?.isPrimary)}>
                                    <DeleteRounded />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Box>
                          </Toolbar>
                        )}

                        <Divider />

                        {/* Primary Resume — fixed, does not scroll */}
                        <Box sx={{ flexShrink: 0 }}>
                          <List
                            subheader={
                              <ListSubheader component="div" sx={{ bgcolor: 'background.paper', lineHeight: '36px' }}>
                                Primary Resume
                                <VerifiedRounded sx={{ color: '#ff9800', fontSize: 18, ml: 1 }} />
                              </ListSubheader>
                            }
                            disablePadding
                          >
                            {primaryResumeDetails && (
                              <ListItemButton sx={{ borderBottom: '1px solid #ddd' }}>
                                <Box sx={{ width: '100%', pb: 1, }}>
                                  <Typography
                                    sx={{
                                      fontSize: '0.85rem',
                                      color: 'rgba(0,0,0,0.7)',
                                      fontWeight: 600,
                                      m: 0,
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {primaryResumeDetails?.full_name}
                                  </Typography>

                                  <Box sx={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
                                    <span style={{ marginRight: 4, whiteSpace: 'nowrap' }}>Role:</span>
                                    <span
                                      title={primaryResumeDetails?.application_title || 'N/A'}
                                      style={{
                                        flex: 1,
                                        minWidth: 0,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {primaryResumeDetails?.application_title || 'N/A'}
                                    </span>
                                  </Box>

                                  <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                                    <span>Experience: {primaryResumeDetails?.total_experience || 'N/A'} years</span>
                                    <span>{primaryResumeDetails?.created ? moment(primaryResumeDetails?.created).fromNow() : 'N/A'}</span>
                                  </Box>
                                </Box>
                              </ListItemButton>
                            )}
                          </List>

                          <Typography
                            sx={{
                              color: 'text.secondary',
                              fontSize: 14,
                              px: 2,
                              pb: 1,
                              pt: 0.5,
                              flexShrink: 0,
                            }}
                          >
                            All Resumes
                          </Typography>
                        </Box>

                        {/* All Resumes list — scrollable only */}
                        <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
                          {resumes?.map((resume, index) => (
                            <React.Fragment key={resume?.resume_id ?? index}>
                              <ListItemButton
                                sx={{
                                  p: 0,
                                  mx: 1,
                                  position: 'relative',
                                  overflow: 'hidden',
                                  bgcolor:
                                    selectedResume?.resume_id === resume?.resume_id ? 'rgba(25,118,210,0.08)' : 'white',
                                  '&:hover': {
                                    bgcolor: '#f5f5f5',
                                    '.more-icons': { display: 'flex' },
                                  },
                                }}
                                onClick={() => handleFileChange(resume)}
                                onMouseOver={() => setHoverIndex(index)}
                                onMouseLeave={() => setHoverIndex(null)}
                              >
                                <Grid container>
                                  <Grid item xs={12} sx={{ p: 1, position: 'relative' }}>
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 0.5,
                                        minWidth: 0,
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontSize: '0.85rem',
                                          color: 'rgba(0,0,0,0.7)',
                                          fontWeight: 600,
                                          m: 0,
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                          cursor: 'pointer',
                                        }}
                                        onClick={() => handleView('resume_view')}
                                      >
                                        {resume.full_name}
                                      </Typography>
                                      {Number(resume?.isPrimary) === 1 && (
                                        <Tooltip title="Primary Resume">
                                          <VerifiedRounded
                                            sx={{ color: '#ff9800', fontSize: 16, flexShrink: 0 }}
                                          />
                                        </Tooltip>
                                      )}
                                    </Box>

                                    <Typography
                                      noWrap
                                      title={`Role: ${resume.application_title || 'N/A'}`}
                                      sx={{ fontSize: 12, m: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    >
                                      Role: {resume.application_title || 'N/A'}
                                    </Typography>
                                    <Typography sx={{ fontSize: 12, m: 0 }}>
                                      Experience:{' '}
                                      {resume.total_experience?.includes('+') ? resume.total_experience : `${resume.total_experience} years`}
                                    </Typography>

                                    <Typography
                                      sx={{
                                        fontSize: 12,
                                        position: 'absolute',
                                        right: hoverIndex === index ? 40 : 8,
                                        bottom: 8,
                                        color: '#757575',
                                        transition: 'right 0.3s ease-in-out',
                                      }}
                                    >
                                      {resume.created ? moment(resume.created).fromNow() : ''}
                                    </Typography>

                                    <Box
                                      className="more-icons"
                                      sx={{
                                        display: 'none',
                                        alignItems: 'center',
                                        gap: 1,
                                        position: 'absolute',
                                        right: 8,
                                        bottom: 8,
                                        zIndex: 2,
                                      }}
                                    >
                                      <Tooltip title="Delete Resume">
                                        <IconButton
                                          aria-label="Delete resume"
                                          size="small"
                                          onClick={() => deleteResume(resume?.resume_id, resume?.isPrimary)}
                                          sx={{ color: '#d32f2f', p: 0 }}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </ListItemButton>
                              <Divider sx={{ my: 1 }} />
                            </React.Fragment>
                          ))}
                        </Box>
                      </Paper>
                    </Grid>
                    <Grid item xs={isMobile || isTablet || isDesktopSmall ? 12 : 9} sx={{ height: "100%", overflowY: "auto" }}  >
                      {selectedResume ? (
                        <>
                          <Grid container alignItems="center">
                            <Paper
                              elevation={3}
                              sx={{

                                marginBottom: "5px",
                                p: 2,
                                display: "flex",
                                border: "1px solid rgb(224, 230, 247)",
                                borderRadius: 2,
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                width: "100%",
                              }}
                            >
                              {/* Left Section: Candidate Details */}
                              <Grid item xs={12} md={8}>
                                <Box sx={{ position: "relative" }}>
                                  <Button
                                    sx={{
                                      position: "absolute",
                                      top: 0,
                                      right: 0,
                                      minWidth: "auto",
                                      padding: 1,
                                      zIndex: 1,
                                      color: isEditing ? "#4caf50" : "black",
                                      display: selectedResume?.isPrimary === 1 ? "block" : "none"
                                    }}
                                    onClick={handleEditClick}
                                  >
                                    {isEditing ? <CheckBox /> : <ModeEditOutlineOutlinedIcon />}
                                  </Button>
                                  {/* Avatar & Candidate Info */}
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                                    <Avatar
                                      src={selectedResume?.image ? `${Key.aws_bucket_profile}/attachments/user_${selectedResume?.uid}/profileimages/${selectedResume?.image}` : null}
                                      alt={selectedResume?.first_name || "Candidate Name"}
                                      sx={{
                                        width: "130px",
                                        height: "130px",
                                        fontSize: "25px",
                                        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                                        border: "3px solid white",
                                      }}

                                    />

                                    <Box>
                                      <Typography variant="h6" sx={{ color: "rgb(5, 38, 78)", fontWeight: 600 }}>
                                        {selectedResume?.full_name}
                                      </Typography>
                                      <Typography variant="body2" sx={{ color: "gray" }}>
                                        {selectedResume?.application_title || "Job Title"}
                                      </Typography>
                                      {/* Contact Info */}
                                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                                        {isValidString(selectedResume?.email_address) ? (
                                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Email sx={{ fontSize: 18, color: "gray" }} />
                                            <Typography
                                              variant="body2"
                                              title={selectedResume?.email_address || "N/A"}
                                              sx={{ wordBreak: "break-all" }}
                                            >
                                              {typeof selectedResume.email_address === "string"
                                                ? selectedResume.email_address.toLowerCase()
                                                : "N/A"}
                                            </Typography>
                                            <Verified sx={{ fontSize: 16, color: "green" }} />
                                          </Box>
                                        ) : null}

                                        {isValidString(selectedResume?.home_phone) ? (
                                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Phone sx={{ fontSize: 18, color: "gray" }} />
                                            <Typography
                                              variant="body2"
                                              title={selectedResume?.home_phone || "N/A"}
                                              sx={{ wordBreak: "break-all" }}
                                            >
                                              {typeof selectedResume.home_phone === "string"
                                                ? selectedResume.home_phone
                                                : "N/A"}
                                            </Typography>
                                            <Verified sx={{ fontSize: 16, color: "green" }} />
                                          </Box>
                                        ) : null}
                                      </Box>
                                    </Box>
                                  </Box>
                                </Box>

                                {/* Social Icons and Button Group */}
                                <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                                  {(selectedResume?.linkedin_url || candidateDetails?.linkedin_url) && (
                                    <IconButton
                                      href={selectedResume?.linkedin_url || candidateDetails?.linkedin_url}
                                      target="_blank"
                                      sx={{
                                        bgcolor: "rgba(0, 0, 0, 0.04)",
                                        fontSize: 20,
                                        width: 30,
                                        height: 30,
                                      }}
                                    >
                                      <FaLinkedinIn />
                                    </IconButton>
                                  )}
                                  {(selectedResume?.github || candidateDetails?.github) && (
                                    <IconButton
                                      href={selectedResume?.github || candidateDetails?.github}
                                      target="_blank"
                                      sx={{
                                        bgcolor: "rgba(0, 0, 0, 0.04)",
                                        fontSize: 20,
                                        width: 30,
                                        height: 30,
                                      }}
                                    >
                                      <FaGithub />
                                    </IconButton>
                                  )}
                                  {(selectedResume?.skype_id || candidateDetails?.skype_id) && (
                                    <IconButton
                                      href={selectedResume?.skype_id || candidateDetails?.skype_id}
                                      target="_blank"
                                      sx={{
                                        bgcolor: "rgba(0, 0, 0, 0.04)",
                                        fontSize: 20,
                                        width: 30,
                                        height: 30,
                                      }}
                                    >
                                      <FaSkype />
                                    </IconButton>
                                  )}
                                  {(selectedResume?.stack_overflow || candidateDetails?.stack_overflow) && (
                                    <IconButton
                                      href={selectedResume?.stack_overflow || candidateDetails?.stack_overflow}
                                      target="_blank"
                                      sx={{
                                        bgcolor: "rgba(0, 0, 0, 0.04)",
                                        fontSize: 20,
                                        width: 30,
                                        height: 30,
                                      }}
                                    >
                                      <FaStackOverflow />
                                    </IconButton>
                                  )}
                                </Box>
                                {/* Button Group (Resume/Profile) */}
                                <Box sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  //mt: 2,
                                  mb: 2,
                                  width: "100%"
                                }}>
                                  <ButtonGroup
                                    variant="contained"
                                    sx={{
                                      borderRadius: "8px",
                                      overflow: "hidden",
                                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                      width: "fit-content"
                                    }}
                                  >
                                    <Button
                                      onClick={() => handleView("resume_view")}
                                      sx={{
                                        textTransform: "none",
                                        fontSize: "14px",
                                        padding: "8px 24px",
                                        backgroundColor: selectedButton === "resume_view" ? "#0077B5" : "white",
                                        color: selectedButton === "resume_view" ? "white" : "black",
                                        fontWeight: 500,
                                        borderRight: "1px solid #ccc",
                                        "&:hover": {
                                          backgroundColor: selectedButton === "resume_view" ? "#005A8C" : "#E0E0E0",
                                        },
                                      }}
                                    >
                                      📄 Resume
                                    </Button>
                                    <Button
                                      onClick={() => handleView("profile_view")}
                                      sx={{
                                        textTransform: "none",
                                        fontSize: "14px",
                                        padding: "8px 24px",
                                        backgroundColor: selectedButton === "profile_view" ? "#0077B5" : "white",
                                        color: selectedButton === "profile_view" ? "white" : "black",
                                        fontWeight: 500,
                                        "&:hover": {
                                          backgroundColor: selectedButton === "profile_view" ? "#005A8C" : "#E0E0E0",
                                        },
                                      }}
                                    >
                                      👤 Profile
                                    </Button>
                                  </ButtonGroup>
                                </Box>
                              </Grid>

                              {/* Right Section: Image */}
                              <Grid item xs={12} md={4}>
                                <Box sx={{ position: "relative", width: "100%", height: "auto", overflow: "hidden" }}>
                                  <img
                                    src={introImg}
                                    alt="Self-introduction video"
                                    style={{
                                      width: "100%",
                                      height: "auto",
                                      opacity: 0.5,
                                    }}
                                  />
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: "50%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      color: "white",
                                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                                      padding: "10px 20px",
                                      borderRadius: "5px",
                                      fontWeight: "bold",
                                      textAlign: "center",
                                    }}
                                  >
                                    Enhance your profile—video resume feature is on its way
                                  </Box>
                                </Box>
                              </Grid>
                            </Paper>
                          </Grid>

                          {/* Main Content Section */}
                          <Paper elevation={2} sx={{ height: "calc(100vh - 64px)", overflowY: "auto" }}>
                            {open === "resume_view" ? (
                              selectedResume.resume_id ? (
                                <ResumePdfViewer resume_id={selectedResume.resume_id} file_name={selectedResume.filename} />
                              ) : (
                                <Typography align="center" sx={{ p: 2 }}>No resume selected</Typography>
                              )
                            ) : open === "profile_view" ? (
                              <CandidateDetailsView candidateDetails={candidateDetails} resume_id={selectedResume.resume_id} />
                            ) : (
                              <></>
                            )}
                          </Paper>
                        </>
                      ) : (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', p: 4 }}>
                          <Typography variant="h6" color="text.secondary">
                            Please select a resume to view details
                          </Typography>
                        </Box>
                      )}
                    </Grid>
                  </Grid>

                  <Modal
                    open={openFileUpload}
                    onClose={() => {
                      setOpenFileUpload(false);
                      // dispatch(clearRedirect());
                    }}
                  >
                    <Slide
                      direction="left"
                      in={openFileUpload}
                      container={openFileUploadRef.current}
                      mountOnEnter
                      unmountOnExit
                      timeout={{ enter: 1000, exit: 1000 }}
                    >
                      <Paper
                        elevation={4}
                        style={{
                          transition: "opacity 2s ease-in-out",
                          ...modalParseStyles,
                        }}
                      >
                      </Paper>
                    </Slide>
                  </Modal>
                  <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  >
                    <Alert
                      onClose={handleSnackbarClose}
                      severity={snackbarSeverity}
                      sx={{ width: "100%" }}
                    >
                      {snackbarMessage}
                    </Alert>
                  </Snackbar>
                </Box>
              </Grid>) : activeCandidates?.length === 0 ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexGrow: 1,
                }}
              >
                <Typography textAlign="center">
                  Click on Add Candidate to add new candidate
                </Typography>
              </Box>
            ) : (
              <Grid item xs={9.6} sx={{ height: "100%", minHeight: 0 }}>
                <Paper
                  elevation={2}
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "8px",
                  }}
                >
                  <Typography color="text.secondary">
                    No candidate found
                  </Typography>
                </Paper>
              </Grid>
            )}

            <Dialog
              fullWidth
              maxWidth="xs"
              open={openFileUpload}
              onClose={() => {
                if (activeCandidates.length === 0) {
                  setNoCandidateFound(true);
                }
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  paddingRight: 1,
                  paddingTop: 1,
                  justifyContent: "flex-end",
                  cursor: "pointer"
                }}
              >
                <CloseIcon onClick={() => { setOpenFileUpload(false) }} />
              </Box>
              <Box>
                {uploadContext === "add_candidates" && (
                  <AddCandidate
                    check="add_candidates"
                    closeResumeParserModal={closeResumeParserModal}
                    popupsHandler={popupsHandler}
                    fetchResumesAfterUpload={fetchResumesAfterUpload}
                  />
                )}
                {uploadContext === "add_resumes" && (
                  <FileUploader
                    check="add_resumes"
                    closeResumeParserModal={closeResumeParserModal}
                    popupsHandler={popupsHandler}
                  />
                )}
              </Box>
            </Dialog>

            <Dialog
              open={noCandidateFound}
              sx={{ "& .MuiDialog-paper": { width: "400px" } }} // Adjusting width
              fullWidth
              maxWidth="xs"
            >
              <DialogContent sx={{ padding: "15px", textAlign: "center" }}>
                <img
                  src={Nocandidate}
                  alt="Placeholder"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                    borderRadius: "8px",
                    marginBottom: "16px",
                  }}
                />
                <Typography variant="body1" sx={{ padding: "5px" }}>
                  No Candidate data was found based on the current search criteria.
                </Typography>
                <Box mt={2} display="flex" justifyContent="center" gap={2}>
                  <Button
                    onClick={() => {
                      skipResumeFetchRef.current = true;
                      setUploadContext("add_candidates");
                      setOpenFileUpload(true);
                      setNoCandidateFound(false);
                    }}
                    color="primary"
                    variant="contained"
                  >
                    Add Candidate
                  </Button>
                  <Button
                    onClick={handleCloseDialog}
                    color="primary"
                    variant="outlined"
                  >
                    Close
                  </Button>
                </Box>
              </DialogContent>
            </Dialog>
            <Dialog open={editPopupOpen} onClose={handleCancel} maxWidth="sm" fullWidth>
              <DialogTitle>Edit Profile</DialogTitle>
              <DialogContent>
                <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
                  <TextField
                    label="Job Title"
                    value={editedTitle}
                    onChange={(e) => setEditedTitle(e.target.value)}
                    size="small"
                    required
                    error={!editedTitle}
                    helperText={!editedTitle ? "Job Title is required" : ""}
                    sx={{
                      width: "calc(100% - 80px)",
                      margin: "9px 40px",
                      "& .MuiInputBase-root": { height: "50px" },
                      "&:hover": {
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        transition: "all 0.3s ease-in-out",
                      },
                    }}
                  />
                  {/* Phone Row with country selection */}
                  <Box
                    sx={{
                      width: "calc(100% - 80px)",
                      margin: "9px 40px",
                      position: "relative",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        border: phoneError
                          ? "1.5px solid #d32f2f"
                          : "1.5px solid #c4c4c4",
                        borderRadius: "4px",
                        background: "#fff",
                        height: "50px",
                        transition: "border-color 0.3s",
                        "&:focus-within": {
                          borderColor: "#1976d2",
                        },
                      }}
                    >
                      <Phone sx={{ fontSize: 20, color: "gray", ml: 1, mr: 1 }} />
                      <Box
                        sx={{
                          flex: 1,
                          ".PhoneInput": { width: "100%" },
                          ".PhoneInputInput": {
                            width: "100%",
                            height: "48px",
                            border: "none",
                            outline: "none",
                            fontSize: "16px",
                            background: "transparent",
                            boxSizing: "border-box",
                            padding: "0 0 0 0",
                          },
                          ".PhoneInputCountry": {
                            marginRight: "8px",
                            height: "48px",
                            display: "flex",
                            alignItems: "center",
                          },
                          ".PhoneInputCountrySelect": {
                            height: "48px",
                          },
                        }}
                      >
                        <PhoneInput
                          defaultCountry="US"
                          international
                          placeholder="Enter phone number"
                          value={editedPhone}
                          onChange={handlePhoneChange}
                          error={phoneError ? phoneError : undefined}
                        />
                      </Box>
                    </Box>
                  </Box>
                  {phoneError && (
                    <Typography color="error" variant="caption" sx={{ ml: 7, mb: 1 }}>
                      {phoneError}
                    </Typography>
                  )}
                  <TextField
                    label="LinkedIn URL"
                    value={editedLinkedIn}
                    onChange={(e) => setEditedLinkedIn(e.target.value)}
                    size="small"
                    placeholder="https://www.linkedin.com/in/your-profile"
                    sx={{
                      width: "calc(100% - 80px)",
                      margin: "9px 40px",
                      "& .MuiInputBase-root": { height: "50px" },
                      "&:hover": {
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        transition: "all 0.3s ease-in-out",
                      },
                    }}
                  />
                  <TextField
                    label="GitHub URL"
                    value={editedGitHub}
                    onChange={(e) => setEditedGitHub(e.target.value)}
                    size="small"
                    placeholder="https://github.com/your-profile"
                    sx={{
                      width: "calc(100% - 80px)",
                      margin: "9px 40px",
                      "& .MuiInputBase-root": { height: "50px" },
                      "&:hover": {
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        transition: "all 0.3s ease-in-out",
                      },
                    }}
                  />
                  <TextField
                    label="Stack Overflow URL"
                    value={editedStackOverflow}
                    onChange={(e) => setEditedStackOverflow(e.target.value)}
                    size="small"
                    placeholder="https://stackoverflow.com/users/your-id"
                    sx={{
                      width: "calc(100% - 80px)",
                      margin: "9px 40px",
                      "& .MuiInputBase-root": { height: "50px" },
                      "&:hover": {
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        transition: "all 0.3s ease-in-out",
                      },
                    }}
                  />
                </Box>
              </DialogContent>
              <DialogActions sx={{
                display: 'flex',
                justifyContent: 'space-between',
                px: 8,
                pb: 3,
                pt: 2
              }}>
                <Button
                  onClick={handleCancel}
                  variant="outlined"
                  color="secondary"
                  sx={{ width: "120px" }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  variant="contained"
                  color="primary"
                  disabled={loading || !editedTitle}
                  sx={{ width: "120px" }}
                >
                  {loading ? <CircularProgress size={20} /> : "Save"}
                </Button>
              </DialogActions>
            </Dialog>
            {/* Inactive Reason Dialog */}
            <Dialog open={openInactiveDialog} onClose={() => setOpenInactiveDialog(false)} maxWidth="sm" fullWidth>
              <DialogTitle>Move to Inactive</DialogTitle>
              <DialogContent>
                <Box sx={{ mt: 1 }}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Enter reason for moving to inactive..."
                    value={inactiveReason}
                    onChange={(e) => setInactiveReason(e.target.value)}
                  />
                </Box>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenInactiveDialog(false)}>Cancel</Button>
                <Button
                  onClick={handleMoveToInactive}
                  variant="contained"
                  disabled={isProcessing}
                >
                  {isProcessing ? "Processing..." : "Submit"}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)} maxWidth="sm" fullWidth>
              <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DeleteIcon color="error" />
                Delete Candidates
              </DialogTitle>
              <Divider />
              <DialogContent>
                <Typography sx={{ mb: 2 }}>
                  Are you sure you want to delete {selectedItems.length} selected candidate(s)?
                </Typography>
                <Alert severity="warning">
                  This action will permanently delete key data including credentials, documents, and history.
                  Consider making them inactive instead.
                </Alert>
              </DialogContent>
              <Divider />
              <DialogActions>
                <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
                <Button
                  onClick={handleDeleteCandidates}
                  variant="contained"
                  color="error"
                  disabled={isProcessing}
                >
                  {isProcessing ? "Deleting..." : "Delete"}
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default Admincandidates;